import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { checkForUpdates } from "../utils/jsonUtils";
import PageWrapper from "../components/PageWrapper";
import { settings } from "../data/settings";
import theme from "../theme";
import { useMediaQuery } from "@mui/material";
import SEO from "../components/SEO";

const PageGalerie = ({ pageKey }) => {
  const [images, setImages] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    checkForUpdates(pageKey, (data) => {
      const imageItems = data.elements
        .filter((el) => el.type === "image" && el.content)
        .map((el) => ({
          img: el.content,
          title: el.id,
        }));

      // Mélanger le tableau
      const shuffledItems = [...imageItems];
      for (let i = shuffledItems.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffledItems[i], shuffledItems[j]] = [
          shuffledItems[j],
          shuffledItems[i],
        ];
      }

      setImages(shuffledItems); // maintenant c'est mélangé !
    });
  }, [pageKey]);

  const handleOpen = (img) => {
    setSelectedImage(img);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  return (
    <PageWrapper style={{ backgroundColor: "#000", color: "#fff" }}>
      <SEO pageKey={pageKey} />
      {images && images.length > 0 && (
        <Box
          sx={{
            width: "100%",
            maxWidth: settings.pages.pageMaxWidth,
            margin: "0 auto",
            padding: "0rem",
          }}
        >
          <ImageList
            //variant="quilted"
            variant="masonry"
            cols={isSmallScreen ? 2 : 3}
            gap={"1rem"}
            style={{ padding: "1rem" }}
          >
            {images.map((item, index) => (
              <ImageListItem
                key={`${item.img}-${index}`}
                onClick={() => handleOpen(item.img)}
                sx={{
                  cursor: "pointer",
                  transition: "transform 0.3s ease",
                  "&:hover img": {
                    transform: "scale(1.05)",
                  },
                }}
              >
                <img
                  src={item.img}
                  alt={item.title}
                  loading="lazy"
                  style={{
                    borderRadius: 0,
                    width: "100%",
                    transition: "transform 0.3s ease",
                  }}
                />
              </ImageListItem>
            ))}
          </ImageList>
        </Box>
      )}

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
        <Box
          sx={{
            position: "relative",
            backgroundColor: "#000",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 2,
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#fff",
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
          {selectedImage && (
            <img
              src={selectedImage}
              alt="zoom"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                borderRadius: 0,
              }}
            />
          )}
        </Box>
      </Dialog>
    </PageWrapper>
  );
};

export default PageGalerie;
